<template>
  <div class="appcontent">
    <div class="wallet">
      <div class="wallet_t">
        <div>Transformers</div>
        <div class="ys">wallet</div>
      </div>
      <div class="wallet_c">
        Be sure to back up your private key and mnemonic. Do not even think
        about giving anyone your private key and mnemonic.
      </div>
    </div>
    <div class="wallet1">
      <div class="wallet1_img">
        <img class="img1" src="../../../assets/m/wallet/wallet.png" />
        <img class="img2" src="../../../assets/m/wallet/wallet1.png" />
      </div>
    </div>
    <div class="wallet2">
      <div class="wallet2_io">
        <!-- <div class="wallet2_list" v-show="num == 1 || num == ''">
          <img src="../../../assets/m/wallet/wallet8.png" />
          <div class="wallet2_xiaz">
            <div class="tit_1">iOS & Android scan code download</div>
            <div class="tit_2">iOS & Android</div>
          </div>
        </div>
        <div class="wallet2_list" v-show="num == 2">
          <img src="../../../assets/m/wallet/wallet8.png" />
          <div class="wallet2_xiaz">
            <div class="tit_1">iOS & Android scan code download</div>
            <div class="tit_2">iOS & Android</div>
          </div>
        </div>
        <div class="wallet2_list" v-show="num == 3">
          <img src="../../../assets/m/wallet/wallet8.png" />
          <div class="wallet2_xiaz">
            <div class="tit_1">iOS & Android scan code download</div>
            <div class="tit_2">iOS & Android</div>
          </div>
        </div>
        <div class="wallet2_list" v-show="num == 4">
          <img src="../../../assets/m/wallet/wallet8.png" />
          <div class="wallet2_xiaz">
            <div class="tit_1">iOS & Android scan code download</div>
            <div class="tit_2">iOS & Android</div>
          </div>
        </div> -->
        <div class="wallet2_hd">
          <ul>
            <li :class="num == 1 ? 'active' : ''" @click="num = 1">
              <!-- <a href="https://testflight.apple.com/join/GGauXrEY"> -->
                <img @click="buildPage"
                  class="img1"
                  src="../../../assets/m/wallet/wallet2.png"
                /><span>IOS TestFlight</span>
              <!-- </a> -->
            </li>
            <li :class="num == 2 ? 'active' : ''" @click="num = 2">
              <a href="https://www.tfsc.io/apk/Tick-Wallet.apk">
                <img
                  class="img2"
                  src="../../../assets/m/wallet/wallet3.png"
                /><span>Android APK</span>
              </a>
            </li>
            <li :class="num == 3 ? 'active' : ''" @click="num = 3">
              <img
                @click="buildPage"
                class="img3"
                src="../../../assets/m/wallet/wallet4.png"
              /><span>MacOS</span>
            </li>
            <li :class="num == 4 ? 'active' : ''" @click="num = 4">
              <img
                @click="buildPage"
                class="img4"
                src="../../../assets/m/wallet/wallet5.png"
              /><span>Windows</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="wallet3">
      <div class="wallet3_con">
        <!-- <div><img src="../../../assets/m/tuc.png" /></div> -->
        <div class="bgtu"></div>
        <div class="wallet3_tit">Wallet guide</div>
        <div class="wallet3_content">
          <div>Transformers has a variety of wallet</div>
          <div>apps that cover all platforms,</div>
          <div>including ios mac for Android</div>
          <div>Windows</div>
        </div>
        <div class="w_line"></div>
      </div>
    </div>
    <div class="wallet4">
      <div class="wallet4_con">
        <div class="bgbox">
          <a
            href="https://www.tfsc.io/doc/wallet/desktop-wallet"
            target="__blank"
          >
            <div class="bg_img">
              <img class="bg1" src="../../../assets/m/wallet/1.png" />

              <!-- <div class="bg_title">Windows</div> -->
              <div class="bg_content">
                <div>Installation guide for</div>
                <div>installing transformers</div>
                <div>wallets under Windows</div>
                <!-- Installation guide for installing transformers wallets under
              Windows -->
              </div>
            </div>
            <div class="more">More</div>
          </a>
        </div>
        <div class="bgbox">
          <a
            href="https://www.tfsc.io/doc/wallet/desktop-wallet"
            target="__blank"
          >
            <div class="bg_img">
              <img class="bg2" src="../../../assets/m/wallet/2.png" />
              <!-- <div class="bg_title">Mac OS</div> -->

              <div class="bg_content">
                <div>Installation guide for</div>
                <div>installing transformers</div>
                <div>wallets under Mac OS</div>

                <!-- Installation guide for installing transformers wallets under Mac
              OS -->
              </div>
            </div>
            <div class="more">More</div>
          </a>
        </div>
        <div class="bgbox">
          <a href="https://www.tfsc.io/doc/wallet/app-wallet" target="__blank">
            <div class="bg_img">
              <img class="bg3" src="../../../assets/m/wallet/3.png" />
              <!-- <div class="bg_title">Android</div> -->

              <div class="bg_content">
                <div>Installation guide for</div>
                <div>installing transformers</div>
                <div>wallets under android</div>

                <!-- Installation guide for installing transformers wallets under
              android -->
              </div>
            </div>
            <div class="more">More</div>
          </a>
        </div>
        <div class="bgbox">
          <a href="https://www.tfsc.io/doc/wallet/app-wallet" target="__blank">
            <div class="bg_img">
              <img class="bg4" src="../../../assets/m/wallet/4.png" />
              <!-- <div class="bg_title">iOS</div> -->

              <div class="bg_content">
                <div>Installation guide for</div>
                <div>installing transformers</div>
                <div>wallets under iOS</div>

                <!-- Installation guide for installing transformers wallets under iOS -->
              </div>
            </div>
            <div class="more">More</div>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
// import { Search } from "vant";
// const echarts = require("echarts");
// Vue.use(Search);
export default {
  components: {
    // Search,
  },
  data() {
    return {
      searchValue: "",
      data: [],
      now: new Date(1997, 9, 3),
      oneDay: 24 * 3600 * 1000,
      series: {},
      num: "",
    };
  },
  computed: {},
  created() {},
  mounted() {},
  destroyed() {},
  methods: {
     buildPage() {

      this.$message({
        message: "Coming Soon",
        type: "warning",
      });
    },
  },
};
</script>

<style lang="less" scoped>
// -webkit-filter: blur(9px);
// filter: blur(9px);
.home {
  background: none !important;
}
.appcontent {
  width: 750px;
  margin: 110px auto 0px auto;
  background: #f4f4f4;
  text-align: center;
  .wallet {
    width: 750px;
    padding-top: 121px;
    .wallet_t {
      // margin-top: 124px;
      text-align: center;
      height: 188px;
      font-size: 80px;
      font-family: HarmonyOS Sans-Black, HarmonyOS Sans;
      font-weight: 900;
      color: #000000;
      line-height: 90px;
      .ys {
        color: #cf61dc;
      }
    }
    .wallet_c {
      width: 690px;
      margin: 0 auto;
      height: 80px;
      font-size: 22px;
      margin-top: 30px;
      font-weight: 400;
      color: rgba(0, 0, 0, 0.800000011920929);
      line-height: 40px;
    }
  }
  .wallet1 {
    width: 750px;
    margin-top: 60px;
    .wallet1_img {
      margin: 0 auto;
      width: 600px;
      height: 360px;
      // width: 448px;
      // height: 340px;
      position: relative;
      .img1 {
        width: 600px;
        height: 360px;
      }
      .img2 {
        width: 116.98px;
        height: 228px;
        position: absolute;
        right: 30px;
        bottom: 0px;
      }
    }
  }
  .wallet2 {
    width: 750px;
    // margin-top: 140px;
    // height: 300px;
    .wallet2_io {
      margin: 156px 40px 60px 40px;
      width: 670px;
      // height: 250px;
      // background: #fbfbfd;
      border-radius: 30px 30px 30px 30px;
      opacity: 1;
      .wallet2_list {
        margin: 34px 36px 50px 36px;
        display: flex;
        align-items: left;

        img {
          width: 180px;
          height: 180px;
          margin-top: 34px;
        }
        .wallet2_xiaz {
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          justify-content: center;
          margin-top: 20px;
          margin-left: 40px;
          .tit_1 {
            // height: 42px;
            text-align: left;
            font-size: 32px;
            font-family: HarmonyOS Sans SC-Regular, HarmonyOS Sans SC;
            font-weight: 400;
            color: #717a8a;
            line-height: 42px;
            margin-top: 12px;
          }
          .tit_2 {
            height: 46px;
            font-size: 40px;
            font-family: HarmonyOS Sans SC-Medium, HarmonyOS Sans SC;
            font-weight: 500;
            color: #3d3d3d;
            line-height: 56px;
          }
        }
      }
      .wallet2_hd {
        // margin: 60px 200px 40px 40px;
        ul {
          margin-top: 100px;
          display: flex;
          li {
            width: 128px;
            height: 128px;
            flex: 1;
            background: #f4f4f4;
            display: flex;
            flex-direction: column;
            align-items: center;
            // justify-content: space-around;
            .img1 {
              width: 28px;
              height: 35px;
              margin: 30px 0 20px 0;
            }
            .img2 {
              width: 30px;
              height: 37px;
              margin: 30px 0 20px 0;
            }
            .img3 {
              width: 32px;
              height: 32px;
              margin: 30px 0 20px 0;
            }
            .img4 {
              width: 38px;
              height: 36px;
              margin: 30px 0 20px 0;
            }
            span {
              display: block;
              // width: 84px;
              height: 60px;
              font-size: 18px;
              font-family: HarmonyOS Sans SC-Regular, HarmonyOS Sans SC;
              font-weight: 400;
              color: #3d3d3d;
              line-height: 10px;
            }
          }

          .active {
            width: 128px;
            height: 128px;
            background: #fbfbfd;
            border-radius: 10px 10px 10px 10px;
            opacity: 1;
          }
        }
      }
    }
  }
  .wallet3 {
    margin-top: 240px;
    .wallet3_con {
      margin: 0px 30px;
      position: relative;
      .bgtu {
        // background: url("../../../assets/m/tuc.png") no-repeat center center;
        background-size: cover;
        width: 317px;
        height: 272px;
        margin: 0 auto;
        // -webkit-filter: blur(19px);
        // filter: blur(19px);
      }
      .wallet3_tit {
        height: 94px;
        font-size: 80px;
        font-family: HarmonyOS Sans-Black, HarmonyOS Sans;
        font-weight: 900;
        color: #000000;
        line-height: 90px;
        position: absolute;
        top: 80px;
        left: 100px;
        margin: 0 auto;
      }
      .wallet3_content {
        // width: 434px;
        margin-top: 100px;
        width: 690px;
        height: 160px;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        div {
          font-size: 22px;
          font-family: HarmonyOS Sans-Bold, HarmonyOS Sans;
          font-weight: bold;
          color: #000000;
          line-height: 30px;
          text-align: center;
        }
        div:nth-child(4) {
          margin-bottom: 10px;
        }
        // top: 182px;img1
        // left: 100px;
      }

      .w_line {
        // margin-top: 40px;
        width: 100px;
        height: 8px;
        background: #cf61dc;
        border-radius: 2px 2px 2px 2px;
        opacity: 1;
        margin: 110px auto 50px auto;
      }
    }
  }
  .wallet4 {
    height: 1000px;
    .wallet4_con {
      margin: 0 30px;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      .bgbox {
        height: 440px;
        width: 330px;
        display: flex;
        flex-direction: column;
        .more {
          width: 120px;
          height: 40px;
          width: 120px;
          line-height: 40px;
          text-align: center;
          background: #fbfbfd;
          border-radius: 4px 4px 4px 4px;
          opacity: 1;
          border: 2px solid rgba(255, 255, 255, 0.15000000596046448);
          // border: 1px solid red;
          font-size: 20px;
          font-family: HarmonyOS Sans-Medium, HarmonyOS Sans;
          font-weight: 500;
          color: #000000;

          margin-top: 20px;
        }
        .more:hover {
          height: 40px;
          width: 120px;
          font-size: 20px;
          font-family: HarmonyOS Sans-Medium, HarmonyOS Sans;
          font-weight: 500;
          color: #acacac;
          line-height: 40px;
        }
        .bg_img {
          width: 330px;
          height: 334px;
          background: #000000;
          // background: url("../../../assets/m/wallet/wallet9.png") no-repeat center
          //   center;
          background-size: cover;
          margin-top: 30px;
          position: relative;
          .bg1 {
            width: 214px;
            height: 54px;
            position: absolute;
            top: 80px;
            left: 48px;
          }
          .bg2 {
            width: 234px;
            height: 180px;
            position: absolute;
            left: 48px;
          }
          .bg3 {
            width: 140px;
            height: 89px;
            position: absolute;
            left: 94px;
            top: 62px;
          }
          .bg4 {
            width: 155px;
            height: 82px;
            position: absolute;
            left: 96px;
            top: 72px;
          }
        }
        .bg_title {
          width: 140px;
          height: 26px;
          font-size: 30px;
          font-family: Inter-Bold, Inter;
          font-weight: bold;
          color: #ffffff;
          line-height: 26px;
          position: absolute;
          left: 20px;
          top: 170px;
          text-align: left;
        }
        .bg_content {
          width: 290px;
          height: 120px;
          font-size: 24px;
          font-family: Inter-Regular, Inter;
          font-weight: 400;
          color: #ffffff;
          line-height: 40px;

          position: absolute;
          left: 20px;
          top: 196px;
          text-align: left;
        }
      }
    }
  }
}
</style>
